// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 245 ? "vendor-base" : chunkId) + "-" + {"245":"e5ae0def122df35f4464","1507":"c0b5bfd03480f871f205","2285":"f5a89024ede23cc65393","5804":"dcab85c3b6685d3bf917","8037":"50ca8ecb780b15e1b606"}[chunkId] + ".css";
};